import { useRef } from 'react';
import { CodeBlock, TextAlignLeft } from '@phosphor-icons/react';
import {
  DrawerTooltipContainer,
  type DrawerTooltipContainerRef,
} from 'src/v2/commonComponents/DrawerTooltipContainer';
import { useUniqueId } from 'src/hooks';
import { Message } from 'src/types';
import { CopyMessageToggle } from '../CopyMessageToggle';
import { CopyMessageButton } from '../CopyMessageButton';
import styles from './CopyMessageTool.module.scss';

interface CopyMessageToolProps {
  message: Message;
  disabled?: boolean;
  activeTab?: string;
}

export const CopyMessageTool = ({
  message,
  activeTab,
  disabled = false,
}: CopyMessageToolProps) => {
  const drawerRef = useRef<DrawerTooltipContainerRef>(null);
  const { uniqueId } = useUniqueId();

  const tooltipAnchorId = `copy-message-actions-${uniqueId}-tooltip`;

  const handleTooltipClose = () => {
    drawerRef.current?.onVisibilityToggle();
  };

  return (
    <DrawerTooltipContainer
      ref={drawerRef}
      id={tooltipAnchorId}
      place="top-start"
      offset={8}
      ToggleButton={CopyMessageToggle}
      disabledToggle={disabled}
    >
      <div className={styles.root} onClick={handleTooltipClose}>
        <CopyMessageButton
          activeTab={activeTab}
          withTitle
          icon={CodeBlock}
          title="Copy code blocks"
          message={message}
          disabled={disabled}
          type="code"
          withTooltip={false}
        />

        <CopyMessageButton
          activeTab={activeTab}
          withTitle
          icon={TextAlignLeft}
          title="Copy entire message"
          message={message}
          disabled={disabled}
          withTooltip={false}
        />
      </div>
    </DrawerTooltipContainer>
  );
};
